import {IDynamicSiteItem, ModType} from '../_components/LazyLoading';

export const index: IDynamicSiteItem = {
  [ModType.FRONTEND_CODE]: {
    echart: () => import('echarts') as unknown as any,
  },
};
export default index;
